import Vue from 'vue'
import AlertView from './Alert.vue'
import ConfirmView from './Confirm.vue'

export function apiUrl (url) {
  return '/api' + url
}

export function alert (msg) {
  let AlertIns = Vue.extend(AlertView)
  let alert = new AlertIns({
    el: document.createElement('div'),
    data () {
      return {
        message: msg,
        showflag: true
      }
    },
    methods: {
      close () {
        alert.$remove()
      }
    }
  })
  alert.$appendTo(document.body)
}

export function confirm (msg, ok) {
  let ConfirmIns = Vue.extend(ConfirmView)
  let ins = new ConfirmIns({
    el: document.createElement('div'),
    data () {
      return {
        message: msg,
        showflag: true
      }
    },
    methods: {
      ok () {
        if (typeof (ok) === 'function') {
          ok()
          ins.$remove()
        }
      },
      cancel () {
        ins.$remove()
      }
    }
  })
  ins.$appendTo(document.body)
}

export function dateFormat (date, format) {
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

export function isEmptyObj (obj) {
  if (Object.keys(obj).length > 0) {
    return false
  }
  return true
}

export function downloadURL (url, name) {
  var link = document.createElement("a");
  link.download = name;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



/** WEBPACK FOOTER **
 ** ./src/helper/index.js
 **/